import React, { useState } from 'react';
import { Grid, TextField, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const SearchProject = ({ onSearch }) => {
  const [searchText, setSearchText] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    onSearch(value); // appel API à chaque frappe
  };

  const handleClear = () => {
    setSearchText('');
    onSearch(''); // recherche vide
  };

  return (
    <Grid container spacing={1} alignItems="center" className="search_bar">
      <Grid item>
        <SearchIcon />
      </Grid>
      <Grid item>
        <TextField
          variant="standard"
          label="Chercher"
          value={searchText}
          onChange={handleChange}
        />
      </Grid>
      <Grid item>
        <IconButton onClick={handleClear}>
          <CloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default SearchProject;
